import React from "react";
import axios from 'axios';
import { store } from "../../redux/store";
import { connect } from "react-redux";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import history from "../../auth/history";
import Footer from "../footerComponent/Footer";
import AddedConsumerDetailsSubComponent from "./AddedConsumerSubComp.jsx";
import AddedConsumerSubComp from "./AddedConsumerSubComp.jsx";
import stateCities from "./stateCities";
import { v4 as uuidv4 } from 'uuid';
import tokenErrorHandler from "../tokenErrorHandler";
import { Link } from "react-router-dom";
import { setConsumerAddresp } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class AllConsumer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {

			billerInfoList: [],
			questions: [],
			stateList: [],
			state: '',
			cityListByStateList: [],
			city: '',
			cityList: [],
			cities: [],
			branch: '',
			mobile: '',
			operator: '',
			catValues: [
				{ value: "Select", label: "Select" },
				{ value: "ELECTRICITY", label: "Electricity" },
				{ value: "WATER", label: "Water" },
				{ value: "GAS", label: "LPG Gas" },
			],
			cateGory: '',
			questionMapList: [],
			billerName: '',
			billerCategory: '',
			showAmount: false,
			enteredAmount: '',
			errorMsg: '',
			mailId:'',
			stateError:'',
			billerCategoryError:'',
			billerNameError:'',
		}
	}

	questionMapList = [];



	componentDidMount() {

		this.questionMapList = [];
		var stateCitiesVal = stateCities.getStateCities();
		var stateList = [];
		var cityListByStateList = [];
		var stateListWithCities = stateCitiesVal.states;
		stateListWithCities.map(stateCity => {
			var state = stateCity.state;
			stateList.push(state);
		})

		this.setState({
			stateList: stateList,

		})

	}
	componentWillUnmount() {
	}



	enterName = (event) => {
		event.preventDefault();
		this.setState({
			name: event.target.value,
			nameError:''
		})
	}

	eneterAmount = (event) => {
		event.preventDefault();
		this.setState({
			enteredAmount: event.target.value
		})
	}


	enterBranchName = (event) => {
		event.preventDefault();
		this.setState({
			branch: event.target.value,
			branchError:''
		})
	}

	eneterEmailId= (event) => {
		event.preventDefault();
		this.setState({
			mailId: event.target.value,
			
		})
	}
	stateSelect = (event) => {
		event.preventDefault();
		this.setState({
			state: event.target.value,
			stateError:''
		})
		var cityListByStateList = [];
		var stateCitiesVal = stateCities.getStateCities();
		var stateListWithCities = stateCitiesVal.states;
		stateListWithCities.map(stateCity => {

			var state = stateCity.state;
			if (state == event.target.value) {
				cityListByStateList = stateCity.districts
			}

		})
		this.setState({
			cities: cityListByStateList
		})
	}
	citySelect = (event) => {
		event.preventDefault();
		this.setState({
			city: event.target.value
		})
	}

	billerNameSelect = (event) => {
		event.preventDefault();
		this.questionMapList = [];
		this.setState({
			showAmount: false,
			enteredAmount: ''
		})
		if (event.target.value != 'Select') {
			this.setState({
				billerName: event.target.value,
				questions: [],
				billerNameError:''
			})
			this.state.billerInfoList.map(billerInfo => {
				if (billerInfo.operator == event.target.value) {
					this.setState({
						operator: billerInfo.id
					})

					if (process.env.REACT_APP_SPECIALBILLER.includes(billerInfo.id)) {
						this.setState({
							showAmount: true
						})
					} else {
						this.setState({
							showAmount: false,
							enteredAmount: ''
						})
					}
				}
			})



			this.selectBiller(event.target.value);
		}



	}

	loadBillerByCategories = (value) => {
		this.questionMapList = [];
		this.setState({
			showAmount: false,
			enteredAmount: ''
		})

		this.state.catValues.map(cat => {
			if (cat.label == value) {
				value = cat.value
			}
		})
		

		var loadBillerUrl = '/api/v1/catalog/billpay/biller/by-category/';
		if (value == 'ELECTRICITY') {
			loadBillerUrl = loadBillerUrl + 'ELECTRICITY';
			this.setState({
				cateGory: 'ELECTRICITY',
				billerCategoryError:''
			})
		}

		if (value == 'WATER') {
			loadBillerUrl = loadBillerUrl + 'WATER';
			this.setState({
				cateGory: 'WATER'
			})
		}

		if (value == 'GAS') {
			loadBillerUrl = loadBillerUrl + 'GAS';
			this.setState({
				cateGory: 'GAS'
			})
		}
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}


		httpClient.post(loadBillerUrl, '',
			{ headers }
		).then((response) => {
			if (response.data != null && response.data != undefined && response.data != '') {
				if (response.data.length > 0) {
					var test = {
						operator: 'Select'
					}
					response.data.push(test)
					response.data = response.data.reverse();
					this.setState({
						billerInfoList: response.data
					})

				}
			}


		}).catch(error => {

			this.setState({
				errorMessage: 'Something went wrong in load biller details,please try again later!',
			})
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}


		});
	}

	selectBiller = (selected) => {
		this.questionMapList = [];

		// alert(selected)
		var questions = [];
		this.setState({
			questions: []
		})


		this.state.billerInfoList.map(billerInfo => {

			if (billerInfo.operator == selected) {
				questions = billerInfo.questions;
			}
		})

		setTimeout(() => {
			this.setState({
				questions: questions,
				billerNameError:''
			})
		}, 500);



	}

	billerCateGorySelect = (event) => {
		event.preventDefault();
		this.questionMapList = [];
		this.setState({
			showAmount: false,
			enteredAmount: '',
			billerInfoList:[],
			billerCateGory: event.target.value,
			questions: []
		})
	
		if (event.target.value != 'Select') {
			this.loadBillerByCategories(event.target.value);
		}


	}

	enterQuestionParamsVal = (event, questions) => {
		event.preventDefault();
		if (this.questionMapList.length > 0) {
			this.questionMapList.map(qs => {
				if (qs.parameterName == questions.optionalField) {

					var index = this.questionMapList.indexOf(qs);
					if (index > -1) {
						this.questionMapList.splice(index, 1);
					}

					//qs.parameterValue = event.target.value
				}
			})

		} else {


		}

		var map = {
			parameterName: questions.optionalField,
			parameterValue: event.target.value
		}

		this.questionMapList.push(map)

		console.log(JSON.stringify(this.questionMapList))


		this.setState({
			questionMapList: this.questionMapList
		})





	}

	eneterMobileNo = (event) => {
		event.preventDefault();
		this.setState({
			mobile: event.target.value
		})
	}

	addNewConsumer = (event) => {
		event.preventDefault();
        var validation=true;

		this.setState({
			stateError:'',
			billerCategoryError:'',
			billerNameError:'',

		})
		if(this.state.state==''){
			validation=false;
			this.setState({
				stateError:'Select a state'
			})
		}
		if(this.state.cateGory==''){
			validation=false;
			this.setState({
				billerCategoryError:'Select a Biller Category'
			})
		}
		if(this.state.billerName==''){
			validation=false;
			this.setState({
				billerNameError:'Select a Biller Name'
			})
		}
		
		if(validation==true){
			var requesterId = this.props.clientRequesterId;

			this.setState({
				progress: 'started',
				errorMsg: ''
			})
	
			const addConsumerRequestHeader = {
				msgType: "CREATE_ACCOUNTS",
				service: "billpay-corporate-dashboard",
				src: "create-consumer",
				dst: "create-consumer",
				channel: "WEB",
				requesterId: requesterId,
				requestId: uuidv4(),
				traceId: uuidv4(),
			}
	
	
			var optional = new Map();
	
			this.questionMapList.map(qsMap => {
				optional.set(qsMap.parameterName, qsMap.parameterValue)
	
			})
			if (this.state.enteredAmount != '') {
				optional.set('amount', this.state.enteredAmount)
			}
	
			var fetchRequired = true;
			if (process.env.REACT_APP_SPECIALBILLER.includes(this.state.operator)) {
				fetchRequired = false;
			}
			const consumer = {
				requesterId: requesterId,
				agentId: this.props.agentInfo,
				consumerName: this.state.name,
				branchNameOrId: this.state.branch,
				state: this.state.state,
				city: this.state.city,
				billerCategory: this.state.cateGory,
				billerName: this.state.billerName,
				mobileNo: this.state.mobile,
				optional: optional != null ? Object.fromEntries(optional) : null,
				operator: this.state.operator,
				mailId: this.state.mailId,
				fetchRequired: fetchRequired
			}
	
			var request = {
				header: addConsumerRequestHeader,
				consumer: consumer,
				agentId: this.props.agentInfo
			}
	
	
			const url = "/api/v1/billpay/corp/consumer/add";
	
			const headers = {
				'Authorization': 'Bearer ' + this.props.token,
				'client-id': this.props.agentInfo,
				'role': this.props.clientRole
			}
	
	
			httpClient.post(url, request,
				{ headers }
			).then((response) => {
				if (response.data.response.success == true) {
					store.dispatch(setConsumerAddresp(response.data.addedConsumer));
	
					var goToAddedConsumerDetails=document.getElementById('goToAddedConsumerDetails');
					goToAddedConsumerDetails.click();
	
				} else {
					this.setState({
						errorMsg: response.data.response.displayMsg
					})
				}
	
			}).catch(error => {
	
	
				if (error.message.includes("401")) {
					tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
				}
	
			});
		}
		

	}


	render() {

		return (
			<div>
				<div class="main">
					<LeftMenu />

					<div class="right-side">
						<div class="container-fluid">
							<Link to="/added-consumer-details">
								<button id="goToAddedConsumerDetails"
								hidden={true}
								></button>
							</Link>
							<Header />
							<div class="row">
								<div class="col-12 col-lg-8">
									<div class="card">
										<div class="dashhead">
											<h3>Add New Consumer</h3>
											<div class="backbtn">
												<Link to='/manage-consumer'>
												<button type="button" class="back"
													>Back</button>
												</Link>
												
											</div>
										</div>
										<form onSubmit={this.addNewConsumer}>

											<div class="addform">
												<div class="row">
													<div class="col-12 col-sm-6">
														<div class="form-floating">
															<input type="text" class="form-control" id="name"
																placeholder="Name" onChange={this.enterName}
																required />
															<label for="name">Enter Name</label>
														</div>
														{this.state.nameError != '' &&
															<div class='valid-error'>
																{this.state.nameError}
															</div>}
													</div>


													<div class="col-12 col-sm-6">
														<div class="form-floating">
															<input type="text" class="form-control" id="bid"
																placeholder="Name" onChange={this.enterBranchName}
																required />
															<label for="bid">Branch Name/ID</label>
														</div>
														{this.state.branchError != '' &&
															<div class='valid-error'>
																{this.state.branchError}
															</div>}
													</div>
													{this.state.stateList.length > 0 &&
														<div class="col-12 col-sm-6">
															<div class="form-floating">

																<select required class="form-select" id="state" aria-label=""
																	onChange={this.stateSelect}>
																	{this.state.stateList.map(state => (
																		<option value={state}
																		>{state}</option>
																	))}
																</select>
																<label for="state">State</label>
																{this.state.stateError != '' &&
																<div class='valid-error'>
																	{this.state.stateError}
																</div>}
															</div>
															
														</div>
													}

													{this.state.cities != undefined &&
														this.state.cities.length > 0 &&
														<div class="col-12 col-sm-6">
															<div class="form-floating">

																<select required class="form-select" id="state" aria-label=""
																	onChange={this.citySelect}>
																	{this.state.cities.map(city => (
																		<option value={city}
																		>{city}</option>
																	))}
																</select>


																<label for="city">City</label>
																{this.state.cityError != '' &&
																	<div class='valid-error'>
																		{this.state.cityError}
																	</div>}
															</div>
														</div>
													}

													<div class="col-12 col-sm-6">
														<div class="form-floating">
															<select class="form-select" id="biller" aria-label=""
																onChange={this.billerCateGorySelect}>
																{this.state.catValues.map(billerCategory => (
																	<option value={billerCategory.label}
																	>{billerCategory.label}</option>
																))}
															</select>

															<label for="cat">Biller Category</label>
															{this.state.billerCategoryError != '' &&
																<div class='valid-error'>
																	{this.state.billerCategoryError}
																</div>}
														</div>
													</div>

													{
														this.state.billerInfoList.length > 0 &&
														<div class="col-12 col-sm-6">
															<div class="form-floating">
																<select class="form-select" id="billerNames" aria-label=""
																	onChange={this.billerNameSelect}
																>

																	{this.state.billerInfoList.map(billerName => (
																		<option value={billerName.operator}
																		>{billerName.operator}</option>
																	))}
																</select>
																<label for="biler">Biller Name</label>
																{this.state.billerNameError != '' &&
																<div class='valid-error'>
																	{this.state.billerNameError}
																</div>}
															</div>
														</div>
													}

													{this.state.questions.length > 0 &&
														this.state.questions.map(question => (
															<div class="col-12 col-sm-6">
																<div class="form-floating">
																	<input type="text" class="form-control" id={question.optionalField}
																		placeholder={question.opFieldDisplay} onChange={e => this.enterQuestionParamsVal(e, question)}
																		required />
																	<label for="con">{question.opFieldDisplay}</label>
																</div>
															</div>
														))

													}


													{/* {this.state.questionMapList.length > 0 &&
													this.state.questionMapList.map(questionMap => (
														<div>	<h1>{questionMap.parameterName}</h1>
															<h1>{questionMap.parameterValue}</h1></div>

													))} */}

													{/* {this.state.showAmount == true &&
														<div class="col-12 col-sm-6">
															<div class="form-floating">
																<input type="number" class="form-control" id="mobi"
																	placeholder="Amount"
																	onInput={(e) => e.target.value = e.target.value.slice(0, 6)}
																	onChange={this.eneterAmount}
																	required />
																<label for="mobi">Enter Amount</label>
															</div>
														</div>
													} */}


													<div class="col-12 col-sm-6">
														<div class="form-floating">
															<input type="number" class="form-control" id="mobi"
																placeholder="Mobile no."
																onInput={(e) => e.target.value = e.target.value.slice(0, 11)}
																onChange={this.eneterMobileNo}
																required />
															<label for="mobi">Enter Mobile No.</label>
														</div>
													</div>

													<div class="col-12 col-sm-6">
														<div class="form-floating">
															<input type="text" class="form-control" id="email"
																placeholder="Email ID"
																onChange={this.eneterEmailId}
																required />
															<label for="email">Enter Email ID</label>
														</div>
													</div>

													<div class="col-12">
														<button type="submit" class="btn midbtn"
														// onclick="window.location.href='added-consumer-details.html'"
														>Submit</button>
													</div>
													{this.state.errorMsg != '' &&
														<div class='valid-error'>
															{this.state.errorMsg}</div>}
												</div>
											</div>
										</form>

									</div>
								</div>

								<AddedConsumerSubComp />

							</div>

						</div>
					</div>
				</div>
				<Footer />
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage },
		miscReduce: {  phone, agentInfo,clientRole,token,clientRequesterId } }
) => ({
	errorMessage, phone,agentInfo,clientRole,token,clientRequesterId
});

export default connect(mapStateToProps, null)(AllConsumer);
